import { API_SCHEMES_PATH, API_TAGS_PATH, API_TEST_CASE_PATH } from '@shared/constants/pathsConstants';
import request from '@shared/api/request';
import { TagEntityType } from '../types';

export function getTags(entityType: TagEntityType) {
    return request.get(`/${entityType}/${API_TAGS_PATH}/`);
}

export function addTag(tagText: string, entityType: TagEntityType) {
    return request.post(`/${entityType === 'schemes' ? API_SCHEMES_PATH : API_TEST_CASE_PATH}/${API_TAGS_PATH}/`, {
        text: tagText,
    });
}

export function deleteTag(id: number, entityType: TagEntityType) {
    return request.delete(
        `/${entityType === 'schemes' ? API_SCHEMES_PATH : API_TEST_CASE_PATH}/${API_TAGS_PATH}/${id}/`,
    );
}
